import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getIdToken, login } from './Authentication';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = getIdToken();
      setIsAuthenticated(!!token);
      setIsChecking(false);
    };

    checkAuth();
  }, []);

  const requireAuth = () => {
    const token = getIdToken();
    if (!token) {
      login();
      return false;
    }
    return true;
  };

  const value = useMemo(
    () => ({ isAuthenticated, isChecking, requireAuth }),
    [isAuthenticated, isChecking]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

